/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";

import { Box, Container, ListItem } from "@mui/material";

import { ItemText } from "../components/itemText";
import theme from "../theme";
import { Ticketing } from "../components/homeComponents/ticketing/ticketingView";
import HeaderComp from "../components/header";
import { useToast } from "../hooks/toast";
import { ProfileData } from "./MeuPerfil";
import { useAuth } from "../hooks/auth";
import AccountsService from "../services/accounts";
import { Core } from "../components/homeComponents/core/coreView";
import { SettingsView } from "../components/homeComponents/settings/settingsView";

const Home: React.FC = () => {
  const [profile, setProfile] = React.useState<ProfileData>({} as ProfileData);
  const { addToast } = useToast();
  const { signOut } = useAuth();
  const services = { AccountsService: new AccountsService() };
  const siteType = localStorage.getItem("@Admin:siteType");

  const group = localStorage.getItem("@UserGroup:group");
  const groupParse = JSON.parse(group);

  return (
    <>
      <HeaderComp filtroNaparece={true} homeNaparece={true} />
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          margin: 0,
        }}
      >
        <Container
          sx={{
            display: "flex",
            paddingBottom: "24px",
            paddingTop: "24px",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ListItem>
            <ItemText
              primary="Administração do Site"
              hideSecondary
              primarySx={{
                color: theme.palette.primary.main,
                fontWeight: "bold",
                fontSize: "28px",
                textAlign: "center",
              }}
            />
          </ListItem>
          {/* <Accounts aside={false} /> */}
          {siteType === "PF" ? (
            groupParse?.map((dados: any) =>
              dados?.name === "Marketing" ? (
                <>
                  <Core aside={false} />
                  <SettingsView aside={false} />
                </>
              ) : dados?.name === "Chargeback" ? (
                <Ticketing aside={false} />
              ) : dados?.name === "Sucesso do Cliente" ? (
                <Ticketing aside={false} asideSC={true} />
              ) : (
                <>
                  <Core aside={false} />
                  <Ticketing aside={false} />
                  <SettingsView aside={false} />
                </>
              )
            )
          ) : (
            <SettingsView aside={false} />
          )}
        </Container>
      </Box>
    </>
  );
};

export default Home;
